module.exports = __webpack_public_path__ + "img/directions_map.fe6b3f66.jpg";